export class ChangePasswordRequestDTO{
    oldPassword: string = ''
    newPassword: string = '';

    constructor(data: ChangePasswordRequestDTO){
        this.oldPassword = data.oldPassword;
        this.newPassword = data.newPassword;
    }
}